module.exports = __webpack_public_path__ + "img/k01.8cdfbec5.png";